interface LanguageStepProps {
  userLanguage: string;
  onUserLanguageChange: (lang: string) => void;
  onNext: () => void;
  onBack: () => void;
}

export function LanguageStep({ userLanguage, onUserLanguageChange, onNext, onBack }: LanguageStepProps) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-ink">Your Language</h2>
      <p className="text-sm text-ink/60">
        What language do you write messages in? This helps Clawer translate messages
        to contacts who speak a different language.
      </p>
      <select
        value={userLanguage}
        onChange={(e) => onUserLanguageChange(e.target.value)}
        className="w-full rounded-lg border border-edge px-3 py-2.5 text-sm"
      >
        <option value="en">English</option>
        <option value="ko">Korean</option>
        <option value="es">Spanish</option>
        <option value="zh">Chinese</option>
        <option value="ja">Japanese</option>
        <option value="fr">French</option>
        <option value="de">German</option>
        <option value="pt">Portuguese</option>
        <option value="ar">Arabic</option>
        <option value="hi">Hindi</option>
        <option value="th">Thai</option>
        <option value="vi">Vietnamese</option>
        <option value="id">Indonesian</option>
      </select>
      <div className="flex gap-2 pt-2">
        <button onClick={onBack} className="flex-1 rounded-lg border border-edge py-2 text-sm">
          Back
        </button>
        <button onClick={onNext} className="flex-1 rounded-lg bg-accent text-white py-2 text-sm">
          Next
        </button>
      </div>
    </div>
  );
}
